export const UPDATE_REWARD_REQUEST = "UPDATE_REWARD_REQUEST"
export const UPDATE_REWARD_REQUEST_TO_LIST = "UPDATE_REWARD_REQUEST_TO_LIST"
export const UPDATE_EDIT_REWARD_REQUEST = "UPDATE_EDIT_REWARD_REQUEST"
export const UPDATE_REWARD_SELECT_ID = "UPDATE_REWARD_SELECT_ID"
export const CLEAR_REWARD_REQUEST = "CLEAR_REWARD_REQUEST"
export const CLEAR_REWARD_SELECT_ID = "CLEAR_REWARD_SELECT_ID"
export const UPDATE_OPEN_MODAL = "UPDATE_OPEN_MODAL"
export const REWARD_TO_INITIAL = "REWARD_TO_INITIAL"
export const CLEAR_REQUEST_REWARD_LIST = "CLEAR_REQUEST_REWARD_LIST"
export const UPDATE_COUPON_URL = "UPDATE_COUPON_URL"